<a mat-button color="primary" [attr.href]="loginUrl">{{
  'buttons.signIn' | translate
}}</a>
<a mat-flat-button color="accent" [attr.href]="loginUrl">{{
  'buttons.signUp' | translate
}}</a>
